import React from "react";
import ClassNames from "classnames";
import ButtonMUI from "@material-ui/core/Button";
import styles from "./index.module.scss";

function ButtonPill({ prepend, append, className, ...props }) {
  return (
    <ButtonMUI
      className={ClassNames(styles.viewLinkBtn, className)}
      variant="outlined"
      disableRipple
      disableElevation
      {...props}
    >
      {prepend}
      <span className={styles.viewLinkBtnLabel}>{props.children}</span>
      {append}
    </ButtonMUI>
  );
}

export default ButtonPill;
